import { monthStartAndEndDate, getUrlQuerysection } from "../../../../helpers";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useGetProfitAndLossReport } from "../../../../hooks/api/queries";
import { useSelector } from "react-redux";
import { useStoreCurrency } from "../../../../hooks/useStoreCurrency";

export const useAccountingProfitLoss = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { startOfMonth, endOfMonth } = monthStartAndEndDate();
  const { storeHasMultipleCurrency } = useStoreCurrency();
  const { businessDetails } = useSelector(
    (state) => state.profileDetailsReducer,
  );
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const [startDate, setStartDate] = useState(
    searchParams.get("start_date") || startOfMonth,
  );
  const [endDate, setEndDate] = useState(
    searchParams.get("end_date") || endOfMonth,
  );
  const [currentStore, setCurrentStore] = useState(
    storeHasMultipleCurrency
      ? searchParams.get("store_id") || storeList?.[0]?.id
      : "",
  );
  const queries = getUrlQuerysection();

  const {
    isLoading: isLoadingReport,
    data: reportData,
    refetch: fetchProfitAndLossReport,
  } = useGetProfitAndLossReport({ queries, enabled: false });

  const setDateFilter = (data) => {
    const { startDate, endDate } = data;
    searchParams.set("start_date", startDate);
    searchParams.set("end_date", endDate);
    setStartDate(startDate);
    setEndDate(endDate);
    setSearchParams(searchParams, { replace: true });
  };

  const filterByStoreId = (storeId) => {
    setCurrentStore(storeId);
    if (storeId === "ALL_STORES" || storeId === "")
      searchParams.delete("store_id");
    else searchParams.set("store_id", storeId);
    setSearchParams(searchParams, { replace: true });
  };

  return {
    startDate,
    endDate,
    businessName: businessDetails?.business_name,
    reportData: reportData?.data || null,
    isLoadingReport,
    storeList,
    storeHasMultipleCurrency,
    currentStore,
    setDateFilter,
    filterByStoreId,
    fetchProfitAndLossReport,
  };
};
